/**
 * Vorlage fuer die Erwachsenen-Einladung. {{anrede}} wird anhand des QR-Codes
 * aus invitations.ts ersetzt. Die übrigen Angaben können hier unabhängig von
 * der Kinder-Einladung angepasst werden.
 */
export const adultInvitationBannerText = `LEVEL 7 FREIGESCHALTET

[b]{{anrede}}[/b]

[b]ICH WERDE 7[/b]

IHR SEID EINGELADEN ZUM
SUPER-MARIO-GEBURTSTAG!

[left]DATUM:   [b]05.09.2026[/b]
[left]UHRZEIT: [b]14:00 Uhr[/b]

ICH FREUE MICH
AUF EUCH!
GRUß, [b]HENRY[/b]`;
